export const EXPORT_ONE_PROGRAM = 'EXPORT_ONE_PROGRAM';
export const EXPORT_ONE_PROGRAM_SUCCESS = 'EXPORT_ONE_PROGRAM_SUCCESS';

export const exportOneProgram = data => ({
  type: EXPORT_ONE_PROGRAM,
  payload: data,
});
